exports = module.exports = require("../../../../../../../home/el/code/sverkasoft-erp/frontend/node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"PaginationFooter.vue","sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/css-loader?{"sourceMap":true}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-00d6124a","scoped":false,"hasInlineConfig":false}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/utilites/commonUi/PaginationFooter.vue
// module id = JYaq
// module chunks = 0